export default __webpack_public_path__ + "static/media/bo-photo.6b188716.jpeg";